import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SplitPipe } from '../../pipes/split.pipe';
import { TagsPipe } from '../../pipes/tags.pipe';


@Component({
    selector: 'app-tags',
    imports: [CommonModule, MatDialogModule, SplitPipe, TagsPipe],
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss']
})
export class TagsComponent {
   @Input() tags: string = '';

}
